import React, { Component } from 'react';

import {
    BlockStack, TextField, Button, DropZone, Thumbnail, Banner,
} from '@shopify/polaris';
import ToastFunc from '../../../../../components/ToastFunc';
import { reqInsertCreateCampaignImage, reqSaveJsonLdV2 } from '../../../../../api';
import LoadingPageForms from "./LoadingPageForms";
import Language from '../../../../../i18n/Language';
import SaveBarTop from '../../../../../components/SaveBarTop';
const t = Language

class LogoForms extends Component {

    constructor(props) {
        super(props);
        this.state = {

            // 保存按钮加载状态
            firstSaveButtonLoading: false,

            //页面动作
            loading: false,
            loadingPage: false,
            //弹窗
            showToast: false,  //弹窗显示
            showToastText: '',  //弹窗文字
            showToastIserror: false, //弹窗是否错误

            //logo图片1
            files: '',
            fileUpload: '',
            uploadedFiles: '',
            //图片删除按钮
            imgButton: true,
            //父组件传过来的值
            logo_url: props.logo_url,
            organization_name: props.organization_name,
            youtube_url: props.social_media_data.youtube_url ? props.social_media_data.youtube_url : '',
            facebook_url: props.social_media_data.facebook_url ? props.social_media_data.facebook_url : '',
            google_url: props.social_media_data.google_url ? props.social_media_data.google_url : '',
            twitter_url: props.social_media_data.twitter_url ? props.social_media_data.twitter_url : '',
            linkedin_url: props.social_media_data.linkedin_url ? props.social_media_data.linkedin_url : '',
            instagram_url: props.social_media_data.instagram_url ? props.social_media_data.instagram_url : '',
            pinterest_url: props.social_media_data.pinterest_url ? props.social_media_data.pinterest_url : '',
            origin: props.originData,
            isUploadStatus: false, // 上传状态
            initBtnState: true,     // 首次禁用状态
            isShowGifBanner: '',
            isShowSaveBar: false,
        };
    }

    componentDidMount() {
        if (this.state.logo_url) {
            this.setUpdateImage(1, 0, this.state.logo_url);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.organization_name !== this.props.organization_name) {
            this.setState({
                organization_name: nextProps.organization_name,
                youtube_url: nextProps.social_media_data.youtube_url ? nextProps.social_media_data.youtube_url : '',
                facebook_url: nextProps.social_media_data.facebook_url ? nextProps.social_media_data.facebook_url : '',
                google_url: nextProps.social_media_data.google_url ? nextProps.social_media_data.google_url : '',
                twitter_url: nextProps.social_media_data.twitter_url ? nextProps.social_media_data.twitter_url : '',
                linkedin_url: nextProps.social_media_data.linkedin_url ? nextProps.social_media_data.linkedin_url : '',
                instagram_url: nextProps.social_media_data.instagram_url ? nextProps.social_media_data.instagram_url : '',
                pinterest_url: nextProps.social_media_data.pinterest_url ? nextProps.social_media_data.pinterest_url : '',
                origin: nextProps.originData,
            })
        }

        if (nextProps.social_media_data !== this.props.social_media_data) {
            this.setState({
                organization_name: nextProps.organization_name,
                youtube_url: nextProps.social_media_data.youtube_url ? nextProps.social_media_data.youtube_url : '',
                facebook_url: nextProps.social_media_data.facebook_url ? nextProps.social_media_data.facebook_url : '',
                google_url: nextProps.social_media_data.google_url ? nextProps.social_media_data.google_url : '',
                twitter_url: nextProps.social_media_data.twitter_url ? nextProps.social_media_data.twitter_url : '',
                linkedin_url: nextProps.social_media_data.linkedin_url ? nextProps.social_media_data.linkedin_url : '',
                instagram_url: nextProps.social_media_data.instagram_url ? nextProps.social_media_data.instagram_url : '',
                pinterest_url: nextProps.social_media_data.pinterest_url ? nextProps.social_media_data.pinterest_url : '',
                origin: nextProps.originData,
            })
        }

        return true;
    }

    handleInputChange = (value, name) => {
        //修改父组件变量
        this.props.logoInputChangeValue(name, value);
        this.setState({
            [name]: value,
            initBtnState: false,
        }, () => {
            this.checkDataChange();
        })
    }

    // 验证数据变动
    checkDataChange = () => {
        let { origin, logo_url, organization_name, youtube_url, facebook_url, google_url, twitter_url, linkedin_url, instagram_url, pinterest_url } = this.state;
        let _t = origin;
        let isChange = _t.logo_url !== logo_url || _t.organization_name !== organization_name || _t.social_media_data.youtube_url !== youtube_url || _t.social_media_data.facebook_url !== facebook_url || _t.social_media_data.google_url !== google_url || _t.social_media_data.twitter_url !== twitter_url || _t.social_media_data.linkedin_url !== linkedin_url || _t.social_media_data.instagram_url !== instagram_url || _t.social_media_data.pinterest_url !== pinterest_url;
        this.toggleShopifySavebar(isChange);
    }

    //删除图片
    deleteImage = () => {
        this.setState({
            files: '',
            imgButton: true,
            logo: '',
            initBtnState: false,
        }, () => {
            this.setUpdateImage();
            this.toggleShopifySavebar(true);
        });
    }

    //上传图片
    updateImage = (acceptedFiles) => {
        if (acceptedFiles.length === 0) {
            this.setState({
                isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
            })
        } else {
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            if (!validImageTypes.includes(acceptedFiles[0].type)) {
                this.setState({
                    isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
                })
            } else {
                this.setState({
                    files: acceptedFiles[0],
                    initBtnState: false,
                }, () => {
                    this.toggleShopifySavebar(true);
                });
            }

            this.setUpdateImage(1, acceptedFiles[0]);
        }
    };

    //设置图片
    setUpdateImage = async (type, acceptedFiles, img) => {
        this.setState({ isUploadStatus: true, })
        var fileUpload = '';
        var uploadedFiles = '';
        var logo = "";
        if (img) {
            fileUpload = !img && <DropZone.FileUpload />;
            uploadedFiles = img && (
                <div className="addImage">
                    <Thumbnail
                        size="small"
                        alt=''
                        source={img}
                    />
                </div>
            );
            this.setState({
                imgButton: false,
                fileUpload: fileUpload,
                uploadedFiles: uploadedFiles,
                isUploadStatus: false,
            });
        } else if (acceptedFiles) {
            const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
            const filesImg = acceptedFiles
            if (validImageTypes.indexOf(filesImg.type) >= 0) {
                fileUpload = !filesImg && <DropZone.FileUpload />;

                //开启FileReader
                var reader = new FileReader();
                reader.readAsDataURL(filesImg); //读取文件保存在result中
                reader.onload = (e) => {
                    var getRes = e.target.result;//读取的结果在result中
                    const params = { img: getRes, type: filesImg.type };
                    reqInsertCreateCampaignImage(params).then(response => {
                        if (response.code === '200') {
                            uploadedFiles = filesImg && (
                                <div className="addImage">
                                    <Thumbnail
                                        size="small"
                                        alt={filesImg.name}
                                        source={response.data}
                                    />
                                </div>
                            );
                            logo = response.data;
                        } else {
                            fileUpload = <DropZone.FileUpload />;
                            uploadedFiles = '';
                        }

                        this.setState({
                            imgButton: false,
                            fileUpload: fileUpload,
                            uploadedFiles: uploadedFiles,
                            logo_url: logo,
                            isUploadStatus: false,
                        });
                    })
                }
            } else {
                fileUpload = <DropZone.FileUpload />;
                uploadedFiles = ''
                this.setState({
                    fileUpload: fileUpload,
                    uploadedFiles: uploadedFiles,
                    logo_url: logo,
                    isUploadStatus: false,
                });
            }
        } else {
            fileUpload = <DropZone.FileUpload />;
            uploadedFiles = ''
            this.setState({
                fileUpload: fileUpload,
                uploadedFiles: uploadedFiles,
                logo_url: logo,
                isUploadStatus: false,
            });
        }
    }

    //更新数据
    updateStructuredData = async (type) => {
        const state = this.state;
        let params = {};
        let res = '';
        this.setState({ firstSaveButtonLoading: true });
        params = {
            action: "organization",
            organization_name: state.organization_name,
            logo_url: state.logo_url,
            social_media_data: {
                youtube_url: state.youtube_url,
                facebook_url: state.facebook_url,
                google_url: state.google_url,
                twitter_url: state.twitter_url,
                linkedin_url: state.linkedin_url,
                instagram_url: state.instagram_url,
                pinterest_url: state.pinterest_url
            }
        };

        res = await reqSaveJsonLdV2(params)
        this.setState({ firstSaveButtonLoading: false });
        if (res.code === '1000') {
            this.props.show();
        }
        if (res.ack === 1) {
            this.setState({
                initBtnState: true,
            })
            this.toggleShopifySavebar(false);
            this.toggleToast(res.msg, false);
        } else {
            this.toggleToast(res.msg, true);
        }
    }

    //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

    // 监听点击上传
    uploadImageData = () => {
        let objClick = document.querySelector('.Polaris-DropZone')
        if (Boolean(objClick)) {
            objClick.click();
        }
    }

    //点击联系客服
    handleContactService = () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            this.toggleToast(t("Try again later"), true);
        }
    }

    // 设置保存bar
    toggleShopifySavebar = (state) => {
        window.savebarState = state;
        this.setState({
            isShowSaveBar: state,
        })
    }

    // 保存
    handleShopifySave = () => {
        this.updateStructuredData('Organization');
    }

    // 舍弃
    handleShopifyDiscard = () => {
        let { origin } = this.state;
        let _t = origin.social_media_data;
        this.setState({
            logo_url: origin.logo_url,
            organization_name: origin.organization_name,
            youtube_url: _t.youtube_url ? _t.youtube_url : '',
            facebook_url: _t.facebook_url ? _t.facebook_url : '',
            google_url: _t.google_url ? _t.google_url : '',
            twitter_url: _t.twitter_url ? _t.twitter_url : '',
            linkedin_url: _t.linkedin_url ? _t.linkedin_url : '',
            instagram_url: _t.instagram_url ? _t.instagram_url : '',
            pinterest_url: _t.pinterest_url ? _t.pinterest_url : '',
            imgButton: !Boolean(origin.logo_url),
            isUploadStatus: false,
        }, () => {
            this.setUpdateImage(1, 0, origin.logo_url);
            this.toggleShopifySavebar(false);
            this.props.resetData();
        })
    }

    render() {
        const {
            isShowGifBanner,
            // initBtnState,
            firstSaveButtonLoading,
            isUploadStatus,
            isShowSaveBar,

        } = this.state;

        const toastMarkup = this.state.showToast ? <ToastFunc content={this.state.showToastText} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;
        return this.state.loadingPage ? <LoadingPageForms /> : <div className='logoForm'>
            <BlockStack gap={200}>
                <SaveBarTop
                    isShowSaveBar={isShowSaveBar}
                    saveLoading={firstSaveButtonLoading}
                    handleSaveAction={this.handleShopifySave}
                    handleDiscardAction={this.handleShopifyDiscard}
                />
                {
                    isShowGifBanner && <div style={{ marginBottom: '1rem' }}>
                        <Banner
                            title={isShowGifBanner}
                            tone="critical"
                            action={{
                                content: t("Contact us"),
                                onAction: this.handleContactService
                            }}
                            onDismiss={() => {
                                this.setState({ isShowGifBanner: '' })
                            }}
                        >
                        </Banner>
                    </div>
                }
                <div className='form_layout'>
                    <div className='logoOrg'>
                        <div className='flex_layout'>
                            <div className='uploadOrgImg'>
                                <DropZone
                                    accept="image/*"
                                    type="image"
                                    onDrop={(files, acceptedFiles, rejectedFiles) => {
                                        this.updateImage(acceptedFiles)
                                    }}
                                >
                                    {!this.state.uploadedFiles && <div className='add_file_icon'>
                                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.5 6C10.3284 6 11 5.32843 11 4.5C11 3.67157 10.3284 3 9.5 3C8.67157 3 8 3.67157 8 4.5C8 5.32843 8.67157 6 9.5 6Z" fill="#8A8A8A" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6.0179 0.5H7.98211C8.79494 0.499993 9.45056 0.499987 9.98147 0.543364C10.5281 0.588026 11.0082 0.682385 11.4525 0.908726C12.1581 1.26825 12.7317 1.84193 13.0913 2.54754C13.3176 2.99175 13.412 3.4719 13.4566 4.01853C13.5 4.54944 13.5 5.20505 13.5 6.01788V7.98212C13.5 8.79496 13.5 9.45056 13.4566 9.98147C13.412 10.5281 13.3176 11.0082 13.0913 11.4525C12.7317 12.1581 12.1581 12.7317 11.4525 13.0913C11.0082 13.3176 10.5281 13.412 9.98147 13.4566C9.45056 13.5 8.79495 13.5 7.98212 13.5H6.01788C5.20505 13.5 4.54944 13.5 4.01853 13.4566C3.4719 13.412 2.99175 13.3176 2.54754 13.0913C1.84193 12.7317 1.26825 12.1581 0.908726 11.4525C0.682385 11.0082 0.588026 10.5281 0.543364 9.98147C0.499987 9.45056 0.499993 8.79495 0.5 7.98212V6.0179C0.499993 5.20506 0.499987 4.54944 0.543364 4.01853C0.588026 3.4719 0.682385 2.99175 0.908726 2.54754C1.26825 1.84193 1.84193 1.26825 2.54754 0.908726C2.99175 0.682385 3.4719 0.588026 4.01853 0.543364C4.54944 0.499987 5.20506 0.499993 6.0179 0.5ZM4.14068 2.03838C3.68681 2.07547 3.42604 2.1446 3.22852 2.24524C2.80516 2.46095 2.46095 2.80516 2.24524 3.22852C2.1446 3.42604 2.07547 3.68681 2.03838 4.14068C2.00058 4.60331 2 5.19755 2 6.05V7.4785L2.7228 6.61114C3.38159 5.82059 4.57697 5.76637 5.30462 6.49402L7.99999 9.18939L9.17963 8.00974C9.91716 7.27222 11.132 7.3395 11.7836 8.15396L11.9997 8.42404C12 8.27538 12 8.11768 12 7.95V6.05C12 5.19755 11.9994 4.60331 11.9616 4.14068C11.9245 3.68681 11.8554 3.42604 11.7548 3.22852C11.539 2.80516 11.1948 2.46095 10.7715 2.24524C10.574 2.1446 10.3132 2.07547 9.85932 2.03838C9.39669 2.00058 8.80245 2 7.95 2H6.05C5.19755 2 4.60331 2.00058 4.14068 2.03838ZM2.03838 9.85932C2.03622 9.83282 2.03417 9.80589 2.03225 9.7785C2.04743 9.76317 2.06209 9.74707 2.07615 9.73019L3.87513 7.57141C3.96924 7.45848 4.14001 7.45073 4.24396 7.55468L7.46966 10.7804C7.76255 11.0733 8.23742 11.0733 8.53032 10.7804L10.2403 9.0704C10.3457 8.96504 10.5192 8.97465 10.6123 9.09101L11.8252 10.6071C11.8037 10.6674 11.7803 10.7214 11.7548 10.7715C11.539 11.1948 11.1948 11.539 10.7715 11.7548C10.574 11.8554 10.3132 11.9245 9.85932 11.9616C9.39669 11.9994 8.80245 12 7.95 12H6.05C5.19755 12 4.60331 11.9994 4.14068 11.9616C3.68681 11.9245 3.42604 11.8554 3.22852 11.7548C2.80516 11.539 2.46095 11.1948 2.24524 10.7715C2.1446 10.574 2.07547 10.3132 2.03838 9.85932Z" fill="#8A8A8A" />
                                        </svg>
                                    </div>}
                                    {this.state.uploadedFiles}
                                </DropZone>
                            </div>
                            <div className='update-images-button'>
                                <Button size='slim' onClick={this.uploadImageData} loading={isUploadStatus}>{t("Upload photo")}</Button>
                                {
                                    this.state.imgButton ? null : <Button size='slim' disabled={this.state.imgButton || this.state.isUploadStatus} onClick={() => this.deleteImage()} outline>{t("Remove")}</Button>
                                }
                            </div>
                        </div>
                    </div>
                    <TextField
                        type="text"
                        label={t("Business name")}
                        value={this.state.organization_name}
                        id="organization_name"
                        onChange={this.handleInputChange}
                    />
                </div>
                <div className='form_layout'>
                    <TextField
                        type="text"
                        label={t("YouTube URL")}
                        value={this.state.youtube_url}
                        id="youtube_url"
                        onChange={this.handleInputChange}
                    />
                    <TextField
                        type="text"
                        label={t("Facebook URL")}
                        value={this.state.facebook_url}
                        id="facebook_url"
                        onChange={this.handleInputChange}
                    />
                </div>
                <div className='form_layout'>
                    <TextField
                        type="text"
                        label={t("Google+ URL")}
                        value={this.state.google_url}
                        id="google_url"
                        onChange={this.handleInputChange}
                    />
                    <TextField
                        type="text"
                        label={t("Twitter URL")}
                        value={this.state.twitter_url}
                        id="twitter_url"
                        onChange={this.handleInputChange}
                    />
                </div>
                <div className='form_layout'>
                    <TextField
                        type="text"
                        label={t("LinkedIn URL")}
                        value={this.state.linkedin_url}
                        id="linkedin_url"
                        onChange={this.handleInputChange}
                    />
                    <TextField
                        type="text"
                        label={t("Instagram URL")}
                        value={this.state.instagram_url}
                        id="instagram_url"
                        onChange={this.handleInputChange}
                    />
                </div>
                <TextField
                    type="text"
                    label={t("Pinterest URL")}
                    value={this.state.pinterest_url}
                    id="pinterest_url"
                    onChange={this.handleInputChange}
                />
                {/* {
                    !isShopify && <div>
                        <Button disabled={initBtnState} variant='primary' loading={firstSaveButtonLoading} onClick={() => this.updateStructuredData('Organization')}>{t("Save")}</Button>
                    </div>
                } */}
            </BlockStack>
            {toastMarkup}
        </div>;
    }
}

export default LogoForms;